/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".notification-item[_ngcontent-%COMP%]{padding:16px 16px 16px 8px}[_nghost-%COMP%]     .mat-checkbox-inner-container{height:25px;width:25px}"];
export { styles as styles };
